import {
  SupportedLanguageDTO,
  LanguagesService,
} from '@openeducation/oe-rn-services';
import type { Language } from '@openeducation/oe-rn-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';
import { QueryKeys } from '../interfaces/query-keys';

export function useLanguages(language?: Language) {
  const { environment } = useEnvironmentContext();

  const { data: languagesData, isLoading: isLoadingLanguagesData } = useQuery<
    SupportedLanguageDTO[]
  >([QueryKeys.Languages], () =>
    LanguagesService.getSupportedLanguages(environment, language)
  );

  return { languagesData, isLoadingLanguagesData };
}
